import { computed } from "vue";

const useNftDetails = (store) => {
  const nft = computed(() => store.getters["nftDetails/getNft"]);

  const contractAddress = computed(() =>
    store.getters["nftDetails/getByKey"]("contractAddress")
  );

  const isUserCreator = async () => {
    await store.dispatch("auth/fetchMe");
    const me = store.getters["auth/getRegisteredUser"];
    return nft.value.creator.id == me.id;
  };

  const shortenedContractAddress = () => {
    return contractAddress.value
      ? `${contractAddress.value.slice(0, 6)}...${contractAddress.value.slice(
          -4
        )}`
      : "...";
  };

  return {
    nft,
    shortenedContractAddress,
    isUserCreator,
  };
};

export default useNftDetails;
